import {call, put, takeLatest} from 'redux-saga/effects';
import dashboardActions from '../actions/dashboard.actions';
import DashboardApi from '../api/DashboardApi';
import errorActions from '../actions/error.actions';

function* updatePayout(action) {
    try {
        const profile = yield call(DashboardApi.updatePayoutType, action.payload);
        if (profile.status !== 'Error') {
            yield put(
                dashboardActions.updatePayoutSuccess({
                    profile
                })
            );
        } else {
            yield put(errorActions.showErrorMessage(profile));
            yield put(dashboardActions.updatePayoutFailed(profile));
        }
    } catch (e) {
        yield put(dashboardActions.updatePayoutFailed(e));
    }
}

function* fetchDashboardData(action) {
    try {
        const dashboard = yield call(DashboardApi.getDashboardData, action.payload);
        if (dashboard.status === 'Error') {
            yield put(errorActions.showErrorMessage(dashboard));
            yield put(dashboardActions.getDashboardDataFailed());
            return;
        }

        const earnings = yield call(DashboardApi.getEarningsData);
        if (earnings.status === 'Error') {
            yield put(errorActions.showErrorMessage(earnings));
            yield put(dashboardActions.getDashboardDataFailed());
            return;
        }

        const profile = yield call(DashboardApi.getInfluencerProfile);
        if (profile.status === 'Error') {
            yield put(dashboardActions.getDashboardDataFailed());
            yield put(errorActions.showErrorMessage(profile));
            return;
        }

        yield put(
            dashboardActions.getDashboardDataSuccess({
                dashboard,
                earnings,
                profile
            })
        );
    } catch (e) {
        yield put(dashboardActions.getDashboardDataFailed(e.get));
    }
}

function* settingsSaga() {
    yield takeLatest(dashboardActions.TYPES.GET_DASHBOARD_DATA, fetchDashboardData);
    yield takeLatest(dashboardActions.TYPES.UPDATE_PAYOUT, updatePayout);
}

export default settingsSaga;
